import Image from "next/image";
import styled from "styled-components";

import { device } from "@/utils/sizes";

export const StyledModal = styled.div`
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    max-height: 95vh;
    width: 100%;
    height: 100%;
    ${device.lg} {
        flex-direction: row;
        max-height: 95vh;
    }
`;

export const ImageSection = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding: 0;

    ${device.md} {
        max-width: 50%;
        flex-shrink: 0;
    }
`;

export const ImageWrapper = styled.div<{ $aspectRatio: number }>`
    position: relative;
    overflow: hidden;
    width: 100%;
    border-radius: 0.5rem;
    padding-top: ${(props) => (1 / props.$aspectRatio) * 100}%;
    /* Fallback for browsers that support aspect-ratio */
    @supports (aspect-ratio: auto) {
        padding-top: 0;
        aspect-ratio: ${(props) => props.$aspectRatio};
    }
`;

export const StyledImage = styled(Image)`
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    border-radius: 0.5rem;
    object-fit: contain;
`;
export const NavButton = styled.button`
    position: absolute;
    bottom: 0.5rem;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 9999px;
    padding: 0.5rem;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: rgba(0, 0, 0, 0.7);
    }

    &.left {
        left: 0.5rem;
    }

    &.right {
        right: 0.5rem;
    }
`;

export const ControlsWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 0.5rem;
`;

export const MetadataSection = styled.div`
    overflow-y: hidden;
    flex-shrink: 0;
    ${device.lg} {
        max-width: 50%;
        overflow-y: auto;
        flex: 1;
    }
`;
